import { getCookie } from "../utils/globals";

export default function setup(){
	initialiseCookiesBar();

	function initialiseCookiesBar() {
		const COOKIE_SELECTION_LEVEL_NAME = "cofense.cookielevelselection";
		const cookieBar = document.querySelector("[xp-cookie-banner]");

		if (!cookieBar || getCookie(COOKIE_SELECTION_LEVEL_NAME) === "true") {
			return;
		}

		const cookieBarCtas = document.querySelectorAll("[cookie-cta]");

		cookieBarCtas.forEach(function (elem) {
			elem.addEventListener("click", () => {
				cookieBar.classList.remove("is-active");
			});
		});
	}
}
